// Builds a block explorer link for a transaction hash. The base URL is fully env-driven —
// update REACT_APP_EXPLORER_URL when the deployed network changes, nothing else to touch.
export function getExplorerTxUrl(transactionHash) {
  return `${process.env.REACT_APP_EXPLORER_URL}${transactionHash}`;
}

// Same idea, for a block hash — swaps the "/tx/" path segment for "/block/" on the same
// explorer base URL (every explorer this app targets — Arbiscan, Basescan, Etherscan —
// uses that same convention).
export function getExplorerBlockUrl(blockHash) {
  const base = process.env.REACT_APP_EXPLORER_URL || "";
  return `${base.replace(/\/tx\/?$/, "/block/")}${blockHash}`;
}
